<template>
    <CContainer class="fixed-top pt-2">
        <CAlert color="danger" class="d-flex align-items-center" v-for="(error, index) in errors" :key="`error-${index}`">
            <CIcon :content="$options.icons.cilInfo" class="flex-shrink-0 mr-2" width="24" height="24" /> 
            <div>{{ error }}</div>
        </CAlert>
        <CAlert color="success" class="d-flex align-items-center" v-for="(alert, index) in alerts" :key="`alert-${index}`">
            <CIcon :content="$options.icons.cilInfo" class="flex-shrink-0 mr-2" width="24" height="24" /> 
            <div>{{ alert }}</div>
        </CAlert>
    </CContainer>
</template>

<script>
    import { cilInfo } from '@coreui/icons';
    export default {
        icons: {
            cilInfo
        },
        data() {
            return {
                isAuthorized: false,
                alerts: [],
                errors: []
            }
        },
        async mounted() {
            this.$root.$on('showAlert', (item) => {
                this.alerts.push(item);
                setTimeout(() => {
                    this.alerts.shift();
                }, 10000);
            });
            this.$root.$on('showError', (item) => {
                this.errors.push(item);
                setTimeout(() => {
                    this.errors.shift();
                }, 10000);
            });
        },

        methods: {
            isActive(linkPath) {
                return this.$route.path.endsWith(linkPath);
            },
            isDisabled(item) {
                return item.disabled === true;
            }
        },
    };
</script>
<style scoped>
@media (max-width: 576px) {
    .custom-pl-xs a.nav-link {
        padding-left: 0.3rem;
        padding-right: 0.3rem;
    }
}
</style>
